import { valueof } from './Common';
import { AttributeCd, ATTRIBUTE_DISPLAY_STYLE, ATTRIBUTE_STYLE, ColorCd, RoleCd } from './constant';

// テーブルのヘッダー
export type TableHeader = {
  value: string;
  text: string;
  align?: 'start' | 'center' | 'end';
  sortable?: boolean;
  divider?: boolean;
  class?: string | Array<string>;
  width?: string | number;
  filter?: (value: any, search: string, item: any) => boolean;
  sort?: (a: any, b: any) => number;
};

export type Content = {
  name: string;
  explanation: string;
  index: number;
  isFiltered: boolean;
  check: boolean;
};

export type Contents = {
  name: string;
  content: Array<Content>;
  index: number;
  isShow: boolean;
  isSelectClassification: boolean;
};

// ユーザー型
export type User = {
  id: string;
  name: string;
  icon: string;
};

// タスク型
export type Task = {
  id: string;
  title: string;
  category: string;
  userIcon: string;
  person: string;
  priority: string;
  status: string;
  limitDate: string;
};

// タスク詳細型
export type TaskDetail = {
  id: string,
  title: string,
  userIcon: string,
  person: string,
  priority: string,
  category: string,
  status: string,
  limitDate: string,
  postDate: string,
  taskDetail: string,
  attributes: Array<{
    id: number,
    type: string,
    value: string,
    priority: boolean;
  }>,
  comments: Array<{
    userIcon: string,
    person: string,
    postDate: string,
    commentDatail: string;
  }>,
  childTasks: Array<{
    id: string,
    title: string,
    priority: string,
    category: string,
    status: string;
  }>,
  nextTask: {
    id: string,
    title: string,
    priority: string,
    category: string,
    status: string;
  },
  previousTask: {
    id: string,
    title: string,
    priority: string,
    category: string,
    status: string;
  };
};

// タスク追加型
export type TaskAdd = {
  id: string,
  title: string,
  userIcon: string,
  person: string,
  priority: string,
  category: string,
  status: string,
  limitDate: string,
  postDate: string,
  taskDetail: string,
  attributes: Array<{
    id: number,
    type: string,
    value: string,
    priority: boolean;
  }>,
  comments: Array<{
    userIcon: string,
    person: string,
    postDate: string,
    commentDatail: string;
  }>,
  childTasks: Array<{
    id: string,
    title: string,
    priority: string,
    category: string,
    status: string;
  }>,
  nextTask: {
    id: string,
    title: string,
    priority: string,
    category: string,
    status: string;
  },
  previousTask: {
    id: string,
    title: string,
    priority: string,
    category: string,
    status: string;
  };
};


// リアクション型
export type Reaction = {
  id?: string;
  count: number,
  // 自身のリアクションかどうか
  self?: boolean,
  // リアクションをした人リスト
  userList?: Array<User>;
};

// コメント型
export type Comment = {
  id: string;
  postDate: string,
  user: User,
  detail: string;
  reactionList: Array<Reaction>;
};

//WEBサービス型
export type WebService = {
  serviceName: string;
  explanation: string;
  image: Image;
};

// ステータス型
export type Status = {
  title: string | null,
  backgroundColor: string | null,
  fontColor: valueof<keyof typeof ColorCd>;
  descriptionText: string | null;
  isHelp: boolean;
  isOpenView: boolean;
};

// カテゴリー型
export type Category = {
  title: string | null,
  backgroundColor: string | null,
  fontColor: valueof<keyof typeof ColorCd>;
  descriptionText: string | null;
  isHelp: boolean;
  isOpenView: boolean;
};

// 優先度型
export type Priority = {
  title: string | null,
  backgroundColor: string | null,
  fontColor: valueof<keyof typeof ColorCd>;
  descriptionText: string | null;
  isHelp: boolean;
  isOpenView: boolean;
};

// グループビューで使用する属性の型
export interface TaskAttributeGroup {
  taskAttributeValueOptionId: number
  title: string | null,
  backgroundColor: string | null,
  fontColor: valueof<keyof typeof ColorCd>;
  descriptionText: string | null;
  isHelp: boolean;
  isOpenView: boolean;
}

export interface TaskChildViewAttributeGroup {
  attributeCd: valueof<keyof typeof AttributeCd>,
  attributes: TaskAttributeGroup[],
}

// お仕事
export type Job = {
  id: string;
  title: string;
  description: string;
  image: Image;
  jobCategory: string;
  price: number;
  unit: string;
  skills: Array<string>;
  features: Array<string>;
  company: Company;
  workPlace: Company;
  status: string;
  isBookmarked: boolean;
};

export type Company = {
  id: string;
  name: string;
  logo?: Image;
  address: string;
  rate?: number;
  companyUrl: string;
  numberOfEmployee: number;
  president: Worker;
  dateOfEstablishment: Date;
  features: Array<string>;
};

// TODO: 動画対応
export type Image = {
  name: string;
  type: string;
  url: string;
};

export type Skill = {
  jobCategory: string;
  type: string;
  name: string;
  selected: boolean;
};

export type JobSearchTeam = {
  id: number;
  searchTerms: Array<string>;
};

// お仕事詳細
export type JobDetail = {
  id: string;
  title: string;
  whatWeDo: string;
  howToDo: string;
  eyeCatch: Image;
  mainImage: Image;
  subImage: Image;
  jobCategory: string;
  price: number;
  unit: string;
  paymentTerm: string;
  contractType: string;
  skills: Array<string>;
  features: Array<string>;
  company: Company;
  workPlace: Company;
  members: Array<Worker>;
  administrator: Worker;
  conversations: Array<Conversation>;
  status: string;
  isBookmarked: boolean;
  day: string;
  entry: number;
  interest: number;
  preview: number;
};

export type Worker = {
  id: string;
  name: string;
  portrait: Image;
  jobCategory: string;
  skills: Array<string>;
  career: string;
  nature: string;
};

export type Conversation = {
  id: string;
  content: string;
  speaker: Worker;
};

export type ActivityList = {
  accountName: string;
  accountIconUrl: string;
  activityTitle: string;
  activityMessage: string;
  createdAt: string;
};

export type Repository = {
  id: string;
  name: string;
  httpsUri: string;
  sshUri: string;
  description: string;
  lastUpdatedAt: string;
  branchs: Array<Branch>;
};

export type GitHistory = {
  id: string;
  operation: Operation;
  author: Worker;
  updatedAt: string;
};

export type Operation = {
  id: string;
  type: string;
  name: string;
  repositoryId: string;
  repositoryName: string;
  branchId: string;
  branchName: string;
  branchUrl: string;
  commitId: string;
  commitComment: string;
  commitUrl: string;
  description: string;
  url: string;
};

export type Branch = {
  id: string,
  name: string,
  lastUpdatedAt: string,
  pullRequestId: string,
};

export type ApplicantList = {
  accountName: string;
  accountIconUrl: string;
  desiredPayment: number;
  scheduleUptime: number;
  sideBusinessFlag: number;
  scheduledJoinStartTime: string;
  occupation: string;
  jobName: string,
  status: string,
  messageCount: number,
};

export type Message = {
  roll: string;
  message: string;
};

export type Directory = {
  name: string;
  path: string;
};

export type CategoryList = {
  title: string;
};

export type RepresentativeList = {
  title: string;
};

export type PriorityList = {
  title: string;
};

export type StatusList = {
  title: string;
};

export type WorkerList = {
  title: string;
};

export interface TaskList {
  id: number,
  title: string,
  category: string,
  representative: string,
  priority: string,
  status: string,
  worker: string,
  startDate: string,
  deadLine: string,
  schedule: string,
  performance: string,
  projectTitle: string;
}

export interface SelectTaskList {
  readonly taskId: number;
  readonly taskName: string;
}

/**
 * 子課題リストの開閉状態
 */
export type ExpantionState = {
  OPEN: 0;
  CLOSE: 1;
};

/** 表示するメンバーリスト */
export interface MemberList {
  initialNmae: string,
  imgIcon: string,
  fullName: string,
  lastAccessDate: string;
}

/**
 * memberページの応募者カードのアイコンリスト
 */
export interface AccountActionList {
  icon: string,
  color: string,
  notDisabled: boolean,
  title?: string,
  text?: string,
  message?: string,
  clickedText: string;
}

/**
 * private projectMembers
 * AccountListCard・AccountListTable・MemberListBase 3ページに使われている
 */
export interface ProjectMembers {
  projectMemberId: number;
  name: string;
  age: string;
  comment: string;
  roll: string;
  social_position: string;
  payment: string;
  payment_unit: string;
  join_start_date: string;
  join_end_date: string;
  isProper: boolean;
  leavingFlag: boolean;
}

export interface Directories {
  name: string;
}

export interface ActivityHistories {
  title: string;
  subtitle: string;
  userName?: string;
}

export interface WithNumber {
  dialog: Array<number>;
  accountDetail: Array<number>;
  chatMessage: Array<number>;
}

export interface Socials {
  icon: string;
  color: string;
  notDisabled: boolean;
  text: string;
}

export interface MemberDatas {
  x: string;
  y: string;
  memberName: string;
  memberImg: string;
  memberSkill: string;
  memberLink: string;
}

export interface OrganizationProces {
  scheduleNumber: number;
  costNumber: number;
  text: string;
  genre: string;
  limitDate: Array<string>;
  chartLabels: Array<string>;
  chartPoint: Array<number>;
  chartGivenInUnits: number;
}

export type pankuzuList = {
  text: string,
  disabled: boolean,
  href: string,
};

export type FileDatas = {
  name: string,
  image: string,
  type: string,
  size: string,
  updatedAt: string,
  updater: string,
  changerIcon: string,
  category: string;
};

export interface Candidates {
  id: number;
  name: string;
  occupation: string;
  matter: string;
  status: string;
}

export interface Headers {
  text: string;
  align: string;
  sortable: boolean;
  value: string;
}

export interface PageOption {
  count: number;
  max: number;
  min: number;
  current: number;
}

/** 課題一覧画面で使用するプロジェクトメンバー型 */
export interface Representative {
  projectMemberId: number; // カスタム属性人物用
  accountId: number;
  accountName: string;
  role: valueof<keyof typeof RoleCd>;
}

/** 課題詳細画面で使用する固定属性の配列 */
export interface TaskAttribute {
  readonly attribute: string;
  attributeKey: string;
  attributeNumber: number | null;
  style: valueof<keyof typeof ATTRIBUTE_STYLE> | null;
  displayStyle: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null;
  displayFlag: boolean;
  value: string | number | Date | null;
  customFlag: boolean; // カスタム属性かデフォルト属性かを識別するためのフラグ
}

export interface TaskDetailParam {
  taskId: number | null;
  value: string | number | boolean | null;
  attributeKey: string;
  customFlag: boolean;
}

export const AttributeKey = {
  parentTaskId: 'parentTaskId',
  previousTask: 'previousTask',
  nextTask: 'nextTask',
  childTask: 'childTask',
  taskName: 'taskName',
  taskDetail: 'taskDetail',
  registrationPerson: 'registrationPerson',
  currentResponsiblePerson: 'currentResponsiblePerson',
  practitioner: 'practitioner',
  category: 'category',
  priority: 'priority',
  status: 'status',
  milestone: 'milestone',
  eventOccurrenceVersion: 'eventOccurrenceVersion',
  completedReason: 'completedReason',
  supportPhase: 'supportPhase',
  importance: 'importance',
  eventOccurrenceTiming: 'eventOccurrenceTiming',
  eventSource: 'eventSource',
  supportScheduledDate: 'supportScheduledDate',
  releaseScheduledDate: 'releaseScheduledDate',
  confirmationDate: 'confirmationDate',
  startDate: 'startDate',
  deadline: 'deadline',
  scheduledTime: 'scheduledTime',
  completedTime: 'completedTime',
  ticketUnitPrice: 'ticketUnitPrice',
} as const;

export const AttributeName = {
  taskId: '課題ID',
  parentTask: '親課題',
  previousTask: '前課題',
  nextTask: '次課題',
  childTask: '子課題',
  taskName: '課題タイトル',
  taskDetail: '課題詳細',
  registrationPerson: '登録者',
  currentResponsiblePerson: '担当者',
  practitioner: '作業実施者',
  category: 'カテゴリー',
  priority: '優先度',
  status: 'ステータス',
  milestone: 'マイルストーン',
  eventOccurrenceVersion: '事象発生バージョン',
  completedReason: '完了理由',
  supportPhase: '対応フェーズ',
  importance: '重要度',
  eventOccurrenceTiming: '事象発生タイミング',
  eventSource: '事象発生源',
  supportScheduledDate: '対応予定日',
  releaseScheduledDate: 'リリース予定日',
  confirmationDate: '確認日',
  startDate: '開始日',
  deadline: '期限日',
  scheduledTime: '予定時間',
  completedTime: '実績時間',
  ticketUnitPrice: 'チケット単価',
} as const;

/** 課題追加画面で表示するデフォルト属性の一覧 */
export const DefaultCreateTaskAttributes: TaskAttribute[] = [
  {
    attribute: AttributeName.parentTask,
    attributeKey: 'parentTaskId',
    attributeNumber: null,
    style: 'task',
    displayStyle: null,
    displayFlag: true,
    value: null,
    customFlag: false,
  },
  {
    attribute: AttributeName.currentResponsiblePerson,
    attributeKey: 'currentResponsiblePersonId',
    attributeNumber: null,
    style: 'person',
    displayStyle: null,
    displayFlag: true,
    value: null,
    customFlag: false,
  },
  {
    attribute: AttributeName.practitioner,
    attributeKey: 'practitionerId',
    attributeNumber: null,
    style: 'person',
    displayStyle: null,
    displayFlag: true,
    value: null,
    customFlag: false,
  },
  {
    attribute: AttributeName.deadline,
    attributeKey: 'deadline',
    attributeNumber: null,
    style: 'date',
    displayStyle: null,
    displayFlag: true,
    value: null,
    customFlag: false,
  },
  {
    attribute: AttributeName.startDate,
    attributeKey: 'startDate',
    attributeNumber: null,
    style: 'date',
    displayStyle: null,
    displayFlag: true,
    value: null,
    customFlag: false,
  },
  {
    attribute: AttributeName.scheduledTime,
    attributeKey: 'scheduledTime',
    attributeNumber: null,
    style: 'number',
    displayStyle: null,
    displayFlag: true,
    value: null,
    customFlag: false,
  },
  {
    attribute: AttributeName.completedTime,
    attributeKey: 'completedTime',
    attributeNumber: null,
    style: 'number',
    displayStyle: null,
    displayFlag: true,
    value: null,
    customFlag: false,
  },
  {
    attribute: AttributeName.category,
    attributeKey: 'category',
    attributeNumber: null,
    style: 'option',
    displayStyle: null,
    displayFlag: true,
    value: null,
    customFlag: false,
  },
  {
    attribute: AttributeName.priority,
    attributeKey: 'priority',
    attributeNumber: null,
    style: 'option',
    displayStyle: null,
    displayFlag: true,
    value: null,
    customFlag: false,
  },
  {
    attribute: AttributeName.status,
    attributeKey: 'status',
    attributeNumber: null,
    style: 'option',
    displayStyle: null,
    displayFlag: true,
    value: null,
    customFlag: false,
  },
  {
    attribute: AttributeName.ticketUnitPrice,
    attributeKey: 'ticketUnitPrice',
    attributeNumber: null,
    style: 'number',
    displayStyle: null,
    displayFlag: true,
    value: null,
    customFlag: false,
  },
  {
    attribute: AttributeName.milestone,
    attributeKey: 'milestone',
    attributeNumber: null,
    style: 'text',
    displayStyle: null,
    displayFlag: true,
    value: null,
    customFlag: false,
  },
  {
    attribute: AttributeName.eventOccurrenceVersion,
    attributeKey: 'eventOccurrenceVersion',
    attributeNumber: null,
    style: 'text',
    displayStyle: null,
    displayFlag: true,
    value: null,
    customFlag: false,
  },
  {
    attribute: AttributeName.completedReason,
    attributeKey: 'completedReason',
    attributeNumber: null,
    style: 'text',
    displayStyle: null,
    displayFlag: true,
    value: null,
    customFlag: false,
  },
  {
    attribute: AttributeName.supportPhase,
    attributeKey: 'supportPhase',
    attributeNumber: null,
    style: 'text',
    displayStyle: null,
    displayFlag: true,
    value: null,
    customFlag: false,
  },
  {
    attribute: AttributeName.importance,
    attributeKey: 'importance',
    attributeNumber: null,
    style: 'text',
    displayStyle: null,
    displayFlag: true,
    value: null,
    customFlag: false,
  },
  {
    attribute: AttributeName.eventOccurrenceTiming,
    attributeKey: 'eventOccurrenceTiming',
    attributeNumber: null,
    style: 'text',
    displayStyle: null,
    displayFlag: true,
    value: null,
    customFlag: false,
  },
  {
    attribute: AttributeName.eventSource,
    attributeKey: 'eventSource',
    attributeNumber: null,
    style: 'text',
    displayStyle: null,
    displayFlag: true,
    value: null,
    customFlag: false,
  },
  {
    attribute: AttributeName.supportScheduledDate,
    attributeKey: 'supportScheduledDate',
    attributeNumber: null,
    style: 'date',
    displayStyle: null,
    displayFlag: true,
    value: null,
    customFlag: false,
  },
  {
    attribute: AttributeName.releaseScheduledDate,
    attributeKey: 'releaseScheduledDate',
    attributeNumber: null,
    style: 'date',
    displayStyle: null,
    displayFlag: true,
    value: null,
    customFlag: false,
  },
  {
    attribute: AttributeName.confirmationDate,
    attributeKey: 'confirmationDate',
    attributeNumber: null,
    style: 'date',
    displayStyle: null,
    displayFlag: true,
    value: null,
    customFlag: false,
  },
];

/** 課題追加画面で表示するデフォルト属性の一覧 */
export const DefaultTaskTableAttributes: TaskAttribute[] = [
  {
    attribute: AttributeName.taskName,
    attributeKey: 'taskName',
    attributeNumber: null,
    style: 'text',
    displayStyle: null,
    displayFlag: true,
    value: null,
    customFlag: false,
  },
  {
    attribute: AttributeName.category,
    attributeKey: 'category',
    attributeNumber: null,
    style: 'option',
    displayStyle: null,
    displayFlag: true,
    value: null,
    customFlag: false,
  },
  {
    attribute: AttributeName.currentResponsiblePerson,
    attributeKey: 'currentResponsiblePersonId',
    attributeNumber: null,
    style: 'person',
    displayStyle: null,
    displayFlag: true,
    value: null,
    customFlag: false,
  },
  {
    attribute: AttributeName.priority,
    attributeKey: 'priority',
    attributeNumber: null,
    style: 'option',
    displayStyle: null,
    displayFlag: true,
    value: null,
    customFlag: false,
  },
  {
    attribute: AttributeName.status,
    attributeKey: 'status',
    attributeNumber: null,
    style: 'option',
    displayStyle: null,
    displayFlag: true,
    value: null,
    customFlag: false,
  },
  {
    attribute: AttributeName.practitioner,
    attributeKey: 'practitionerId',
    attributeNumber: null,
    style: 'person',
    displayStyle: null,
    displayFlag: true,
    value: null,
    customFlag: false,
  },
  {
    attribute: AttributeName.startDate,
    attributeKey: 'startDate',
    attributeNumber: null,
    style: 'date',
    displayStyle: null,
    displayFlag: true,
    value: null,
    customFlag: false,
  },
  {
    attribute: AttributeName.deadline,
    attributeKey: 'deadline',
    attributeNumber: null,
    style: 'date',
    displayStyle: null,
    displayFlag: true,
    value: null,
    customFlag: false,
  },
  {
    attribute: AttributeName.scheduledTime,
    attributeKey: 'scheduledTime',
    attributeNumber: null,
    style: 'number',
    displayStyle: null,
    displayFlag: true,
    value: null,
    customFlag: false,
  },
  {
    attribute: AttributeName.completedTime,
    attributeKey: 'completedTime',
    attributeNumber: null,
    style: 'number',
    displayStyle: null,
    displayFlag: true,
    value: null,
    customFlag: false,
  },
];

export const DefaultLeftAttributes: TaskAttribute[] = [
  {
    attribute: AttributeName.parentTask,
    attributeKey: 'parentTaskId',
    attributeNumber: null,
    style: null,
    displayStyle: null,
    displayFlag: true,
    value: null,
    customFlag: false,
  },
  {
    attribute: AttributeName.milestone,
    attributeKey: 'milestone',
    attributeNumber: null,
    style: null,
    displayStyle: null,
    displayFlag: true,
    value: null,
    customFlag: false,
  },
  {
    attribute: AttributeName.eventOccurrenceVersion,
    attributeKey: 'eventOccurrenceVersion',
    attributeNumber: null,
    style: null,
    displayStyle: null,
    displayFlag: true,
    value: null,
    customFlag: false,
  },
  {
    attribute: AttributeName.completedReason,
    attributeKey: 'completedReason',
    attributeNumber: null,
    style: null,
    displayStyle: null,
    displayFlag: true,
    value: null,
    customFlag: false,
  },
  {
    attribute: AttributeName.supportPhase,
    attributeKey: 'supportPhase',
    attributeNumber: null,
    style: null,
    displayStyle: null,
    displayFlag: true,
    value: null,
    customFlag: false,
  },
  {
    attribute: AttributeName.importance,
    attributeKey: 'importance',
    attributeNumber: null,
    style: null,
    displayStyle: null,
    displayFlag: true,
    value: null,
    customFlag: false,
  },
  {
    attribute: AttributeName.eventOccurrenceTiming,
    attributeKey: 'eventOccurrenceTiming',
    attributeNumber: null,
    style: null,
    displayStyle: null,
    displayFlag: true,
    value: null,
    customFlag: false,
  },
  {
    attribute: AttributeName.eventSource,
    attributeKey: 'eventSource',
    attributeNumber: null,
    style: null,
    displayStyle: null,
    displayFlag: true,
    value: null,
    customFlag: false,
  },
  {
    attribute: AttributeName.supportScheduledDate,
    attributeKey: 'supportScheduledDate',
    attributeNumber: null,
    style: null,
    displayStyle: null,
    displayFlag: true,
    value: null,
    customFlag: false,
  },
  {
    attribute: AttributeName.releaseScheduledDate,
    attributeKey: 'releaseScheduledDate',
    attributeNumber: null,
    style: null,
    displayStyle: null,
    displayFlag: true,
    value: null,
    customFlag: false,
  },
  {
    attribute: AttributeName.confirmationDate,
    attributeKey: 'confirmationDate',
    attributeNumber: null,
    style: null,
    displayStyle: null,
    displayFlag: true,
    value: null,
    customFlag: false,
  },
];

export const DefaultRightAttributes: TaskAttribute[] = [
  {
    attribute: AttributeName.startDate,
    attributeKey: 'startDate',
    attributeNumber: null,
    style: null,
    displayStyle: null,
    displayFlag: true,
    value: null,
    customFlag: false,
  },
  {
    attribute: AttributeName.scheduledTime,
    attributeKey: 'scheduledTime',
    attributeNumber: null,
    style: null,
    displayStyle: null,
    displayFlag: true,
    value: null,
    customFlag: false,
  },
  {
    attribute: AttributeName.completedTime,
    attributeKey: 'completedTime',
    attributeNumber: null,
    style: null,
    displayStyle: null,
    displayFlag: true,
    value: null,
    customFlag: false,
  },
  {
    attribute: AttributeName.ticketUnitPrice,
    attributeKey: 'ticketUnitPrice',
    attributeNumber: null,
    style: null,
    displayStyle: null,
    displayFlag: true,
    value: null,
    customFlag: false,
  },
];

export interface TaskCustomAttributeValue {
  readonly attribute: string;
  type: valueof<keyof typeof CustomAttributeType>;
}

export const CustomAttributeType = {
  option: 'option',
  date: 'date',
  person: 'person',
  text: 'text',
  number: 'number',
} as const;

export interface CustomAttribute {
  attributeNumber: number; // カスタム属性の数字
  name: string; // カスタム属性名称
  style: valueof<keyof typeof ATTRIBUTE_STYLE> | null; // カスタム属性形式
  displayStyle: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null; // カスタム属性表示形式
  displayFlag: boolean; // カスタム属性表示フラグ
}

export interface CustomTile {
  attributeNumber: number;
  customTiles: Tile[];
}

export interface Tile {
  taskAttributeValueOptionId: number;
  title: string | null;
  backgroundColor: string | null,
  fontColor: valueof<keyof typeof ColorCd>,
}

export interface TaskName {
  readonly value: number;
  readonly text: string;
  readonly category: string | null;
  readonly priority: string | null;
  readonly status: string | null;
}

export const TaskSortParams = {
  allCategory: ['検討', 'タスク', '調査'],
  considerationCategory: '検討',
  taskCategory: 'タスク',
  researchCategory: '調査',
  allStatus: ['未対応', '処理中', '処理済み', '保留', '完了'],
  unsupportedStatus: '未対応',
  processingStatus: '処理中',
  processedStatus: '処理済み',
  savingStatus: '保留',
  completedStatus: '完了',
  allPriority: ['高', '中', '低'],
  highPriority: '高',
  middlePriority: '中',
  lowPriority: '低',
} as const;

export interface TaskFilterPeriodQuery {
  day: boolean;
  week: boolean;
  month: boolean;
  isPeriod: boolean;
}

export interface ColumnSwitch {
  attributeNumber: number;
  attributeName: string;
  displayFlag: boolean;
}

export enum CognitoHostedUIIdentityProvider {
  Cognito = 'COGNITO',
  Google = 'Google',
  Facebook = 'Facebook',
  Amazon = 'LoginWithAmazon'
}

export const TaskStatusDefault: Array<Status> = [
  {
    title: '未対応',
    backgroundColor: 'rgb(250, 95, 126, 0.1)',
    fontColor: '#fa5f7e',
    descriptionText: 'まだ着手していないタスク',
    isHelp: false,
    isOpenView: false,
  },
  {
    title: '処理中',
    backgroundColor: 'rgb(10, 173, 255, 0.1)',
    fontColor: '#0aadff',
    descriptionText: '着手しているタスク',
    isHelp: false,
    isOpenView: false,
  },
  {
    title: '処理済み',
    backgroundColor: 'rgb(98, 209, 128, 0.1)',
    fontColor: '#62d180',
    descriptionText: '対応済みのタスク',
    isHelp: false,
    isOpenView: false,
  },
  {
    title: '保留',
    backgroundColor: 'rgb(235, 178, 45, 0.1)',
    fontColor: '#ebb22d',
    descriptionText: '対応保留中のタスク',
    isHelp: false,
    isOpenView: false,
  },
  {
    title: '完了',
    backgroundColor: 'rgb(27, 128, 54, 0.1)',
    fontColor: '#1b8036',
    descriptionText: '完了しているタスク',
    isHelp: false,
    isOpenView: false,
  },
];

export const GitRepositoryDetailHeaderTitle = {
  tableHeader: {
    codes: 'Codes',
    branches: 'Branches',
    commits: 'Commits',
    network: 'Network',
    pullRequests: 'Pull Requests',
  },
  directoryHeader: {
    file: 'ファイル',
    updates: '最終更新',
    committer: '更新者',
    revision: 'リビジョン',
    message: 'コメント',
  },
  branchHeader: {
    names: 'ブランチ名',
    updates: '更新日',
    diff: 'ブランチ間差分',
    pullRequest: 'プルリクエスト',
    delete: 'ブランチ削除',
  },
  commitHeader: {
    revision: 'リビジョン',
    committer: '登録者',
    message: 'コメント',
    updates: '更新日',
  },
  pullRequestsHeader: {
    relationTask: '関連課題',
    register: '登録者',
    responsiblePerson: '担当者',
  },
} as const;

/**プルリクエストステータス */
export const PULL_REQUEST_STATUS = {
  OPEN: 'open',
  CLOSED: 'closed',
  MERGED: 'merged',
} as const;